import { render, staticRenderFns } from "./QuickInvoiceDetail.vue?vue&type=template&id=b072af9e&scoped=true"
import script from "./QuickInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoiceDetail.vue?vue&type=style&index=0&id=b072af9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b072af9e",
  null
  
)

export default component.exports